import { render, staticRenderFns } from "./store_review.vue?vue&type=template&id=2aed7c38&scoped=true&"
import script from "./store_review.vue?vue&type=script&lang=js&"
export * from "./store_review.vue?vue&type=script&lang=js&"
import style0 from "./store_review.vue?vue&type=style&index=0&id=2aed7c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed7c38",
  null
  
)

export default component.exports